import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";

interface DateFilterMenuProps {
  value: any;
  filterCallback: (value: any) => void;
}

const DateFilterMenu: React.FC<DateFilterMenuProps> = ({
  value,
  filterCallback,
}) => {
  const [operator, setOperator] = useState(value?.operator || "equals");
  const [date, setDate] = useState(value?.value || null);

  const updateFilter = (newOperator: string, newDate: Date | null) => {
    filterCallback({ operator: newOperator, value: newDate });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <Dropdown
        value={operator}
        options={[
          { label: "Равно", value: "equals" },
          { label: "После", value: "after" },
          { label: "До", value: "before" },
        ]}
        onChange={(e) => {
          setOperator(e.value);
          updateFilter(e.value, date);
        }}
      />
      <Calendar
        value={date}
        onChange={(e) => {
          setDate(e.value ?? null);
          updateFilter(operator, e.value ?? null);
        }}
        dateFormat="dd.mm.yy"
        placeholder="Дата"
      />
    </div>
  );
};

export default DateFilterMenu;
